import { DesignData } from '../types';

// The spread an "add pages" click copies: the clicked spread when it is a template, otherwise the
// design's first template spread. Undefined when the design has none.
function resolveTemplateSpreadIndex(designData: DesignData, spreadIndex: number): number | undefined {
  if (designData.spreads[spreadIndex]?.isTemplate) {
    return spreadIndex;
  }
  const index = designData.spreads.findIndex((spread) => spread.isTemplate);
  return index === -1 ? undefined : index;
}

export default resolveTemplateSpreadIndex;
